import { render, staticRenderFns } from "./WinChildHistory.vue?vue&type=template&id=96808194"
import script from "./WinChildHistory.vue?vue&type=script&lang=js"
export * from "./WinChildHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports